require('./helpers/bundle-manifest').register(JSON.parse("{\"2ki5Y\":\"index.js\",\"9hF2M\":\"drinkaware-logo.6156b8df.svg\",\"cXvvd\":\"index.css\"}"));